import React, {useEffect} from 'react';
import {Box, Typography} from '@mui/material';
import ArrWidgetWrapper from '../../../common/arr-widget-wrapper/ArrWidgetWrapper';
import './UsersInActiveProjectsWidget.scss';
import {t} from 'i18next';
import {useUsersInActiveProjectData} from '../../../../hooks/dashboard/useDashboard';

const UsersInActiveProjectsWidget: React.FC<{
  entityId?: number;
  updatedAt?: number;
}> = ({entityId, updatedAt}) => {
  const {data, isLoading, isError, refetch} = useUsersInActiveProjectData(
    entityId || 0
  );

  // Refetch data on updatedAt changes
  useEffect(() => {
    refetch();
  }, [updatedAt]);

  return (
    <ArrWidgetWrapper
      title={t('dashboard.usersInActiveProjectsWidget.title')}
      showInfo
      loading={isLoading}
      error={isError}
      tooltipContent={t('dashboard.usersInActiveProjectsWidget.tooltip')}
    >
      <Box className="users-in-active-projects-root">
        {/* Top Summary */}
        <Box className="summary-row">
          <Box className="summary-item">
            <Typography
              className="typo-text label2_size heading-text"
              data-testid={`active-users-title`}
            >
              {t('dashboard.usersInActiveProjectsWidget.activeUsers')}
            </Typography>
            <Typography
              className="typo-text display2_size"
              data-testid={`active-users-total`}
            >
              {data?.totalActiveUsersAllProjects ?? 0}
            </Typography>
          </Box>
          <Box className="summary-item">
            <Typography
              className="typo-text label2_size heading-text"
              data-testid={`users-inactive-title`}
            >
              {t('dashboard.usersInActiveProjectsWidget.totalUsers')}
            </Typography>
            <Typography
              className="typo-text display2_size"
              data-testid={`users-inactive-total`}
            >
              {data?.totalUsersAllProjects ?? 0}
            </Typography>
          </Box>
        </Box>

        {/* Table Header */}
        <Box className="table-header">
          <Typography
            className="typo-text label2_size table-header-data project-header"
            data-testid={`users-inactive-table-header`}
          >
            {t('dashboard.usersInActiveProjectsWidget.project')}
          </Typography>
          <Typography
            className="typo-text label2_size table-header-data"
            data-testid={`users-inactive-users`}
          >
            {t('dashboard.usersInActiveProjectsWidget.users')}
          </Typography>
        </Box>

        {/* Table Rows */}
        <Box>
          {data?.projectDomainUserDataList.map((proj, idx) => (
            <Box
              key={proj.projectID}
              className={`table-row ${idx % 2 === 0 ? 'row-alt' : ''}`}
            >
              <Typography
                className="project-name typo-text subhead5_size"
                data-testid={`users-inactive-name-${proj.projectID}`}
              >
                {proj.projectName}
              </Typography>
              <Box className="users-col">
                <Typography
                  className="typo-text body3_size"
                  data-testid={`users-inactive-users-${proj.projectID}`}
                >
                  {proj.totalActiveUsers + proj.totalInActiveUsers}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </ArrWidgetWrapper>
  );
};

export default UsersInActiveProjectsWidget;
